import { render, staticRenderFns } from "./DetailIncoming.vue?vue&type=template&id=6561284b&"
import script from "./DetailIncoming.vue?vue&type=script&lang=ts&"
export * from "./DetailIncoming.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports